export default __webpack_public_path__ + "static/media/gallery_11.0fc17863.jpg";